import { render, staticRenderFns } from "./PageContent.ts.vue?vue&type=template&id=0e815a96&"
import script from "./PageContent.ts.vue?vue&type=script&lang=ts&"
export * from "./PageContent.ts.vue?vue&type=script&lang=ts&"
import style0 from "./PageContent.ts.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports